export default "__VITE_ASSET__BumX74p___"